import script from "./CustomerDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDetail.vue?vue&type=style&index=0&id=61ae5016&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ae5016"]])

export default __exports__